var image_viewer_default = {
  "fontElementMap": "e1ADb",
  "imageContainer": "hqeKi",
  "expandButton": "B8NK9",
  "expandIcon": "_9V6Ut",
  "pointer": "Kam4w",
  "imageWrapper": "_2QrYu",
  "imageRatio": "onqYC",
  "image": "AV6yF",
  "imageOverlay": "SXdhm",
  "imagePreload": "_8ht0g",
  "imageHighres": "AUIDF",
  "onlyHighRes": "rGB2L",
  "image_loading": "LWDcI"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
